import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

const log = (...msgs) => {
    if (process.env.NODE_ENV === 'development') console.log(...msgs)
}

ReactDOM.render(<App />, document.getElementById('root'));

global.log = log
global.log('will only log in dev')
console.log('will only log in dev')

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
